import { AutocompleteField } from "./AutocompleteField";
import { BooleanSelectField } from "./BooleanSelectField";
import { CheckboxField } from "./CheckboxField";
import { ColorField } from "./ColorField";
import { NumberField } from "./NumberField";
import { RadioField } from "./RadioField";
import { SelectField } from "./SelectField";
import { TextArea } from "./TextArea";
import { TextField } from "./TextField";
import { DateField, TimeField, TimeFieldWithSeconds, UnixTimestampField } from "./TimeFields";
import { TimeIntervalField } from "./TimeIntervalField";
import { UploadField } from "./UploadField";
export { NumberField } from "./NumberField";
export { TextArea } from "./TextArea";
export { TextField } from "./TextField";
export { CheckboxField } from "./CheckboxField";
export { TimeIntervalField } from "./TimeIntervalField";
export { DateField, UnixTimestampField } from "./TimeFields";
export { ColorField } from "./ColorField";
export { UploadField } from "./UploadField";
export { BooleanSelectField } from "./BooleanSelectField";
export var commonFields = {
  NumberField: NumberField,
  TextArea: TextArea,
  TextField: TextField,
  CheckboxField: CheckboxField,
  TimeIntervalField: TimeIntervalField,
  UnixTimestampField: UnixTimestampField,
  DateField: DateField,
  TimeField: TimeField,
  TimeFieldWithSeconds: TimeFieldWithSeconds,
  ColorField: ColorField,
  UploadField: UploadField,
  BooleanSelectField: BooleanSelectField,
  SelectField: SelectField,
  RadioField: RadioField,
  AutocompleteField: AutocompleteField
};